/** Bounded fresh-capability retries for temporary screen connection failures. */
export function createScreenAutoRetry() {
  const states = new Map<string, { start: number; attempts: number }>();
  return {
    next(botId: string, now = Date.now()): number | null {
      let state = states.get(botId);
      if (!state || now - state.start >= 60_000 || now < state.start) {
        state = { start: now, attempts: 0 };
        states.set(botId, state);
      }
      if (state.attempts >= 3) return null;
      state.attempts++;
      return state.attempts * 1_500;
    },
    reset(botId: string) { states.delete(botId); },
  };
}
